import { UNIT_DOZEN, UNIT_PIECE } from "./common";
import type { PackDef } from "./types";

export const FASHION_PACK: PackDef = {
  id: "fashion",
  version: 1,
  available: true,
  name: { en: "Fashion & clothing", bn: "পোশাক ও ফ্যাশন" },
  description: {
    en: "Clothing, shoe and boutique shops that sell each design in sizes and colours",
    bn: "প্রতিটি ডিজাইন সাইজ ও রঙে বিক্রি করা পোশাক, জুতা ও বুটিক",
  },
  icon: "shirt",
  modules: {
    variants: true,
    batches: false,
    expiry: false,
    serials: false,
    vat: false,
    multi_branch: false,
    storefront: false,
    loans: false,
  },
  baseUnits: [
    UNIT_PIECE,
    { code: "pair", name: { en: "Pair", bn: "জোড়া" }, fractional: false },
    { code: "set", name: { en: "Set", bn: "সেট" }, fractional: false },
    { code: "yard", name: { en: "Yard", bn: "গজ" }, fractional: true },
    { code: "m", name: { en: "Metre", bn: "মিটার" }, fractional: true },
    UNIT_DOZEN,
  ],
  unitConversions: [{ from: "dz", to: "pc", factor: 12 }],
  categories: [
    { en: "Shirts", bn: "শার্ট" },
    { en: "T-shirts & polos", bn: "টি-শার্ট ও পোলো" },
    { en: "Panjabi", bn: "পাঞ্জাবি" },
    { en: "Pants & jeans", bn: "প্যান্ট ও জিন্স" },
    { en: "Saree", bn: "শাড়ি" },
    { en: "Three-piece & salwar kameez", bn: "থ্রি-পিস ও সালোয়ার কামিজ" },
    { en: "Kurti & tops", bn: "কুর্তি ও টপস" },
    { en: "Kids' wear", bn: "শিশুদের পোশাক" },
    { en: "Shoes & sandals", bn: "জুতা ও স্যান্ডেল" },
    { en: "Bags & accessories", bn: "ব্যাগ ও এক্সেসরিজ" },
    { en: "Fabric", bn: "কাপড় (থান)" },
  ],
  customFields: [
    {
      key: "fabric",
      entity: "item",
      type: "text",
      label: { en: "Fabric", bn: "কাপড়" },
      required: false,
      searchable: true,
    },
    {
      key: "gender",
      entity: "item",
      type: "select",
      label: { en: "For", bn: "কার জন্য" },
      required: false,
      searchable: false,
      options: [
        { value: "men", label: { en: "Men", bn: "ছেলে" } },
        { value: "women", label: { en: "Women", bn: "মেয়ে" } },
        { value: "kids", label: { en: "Kids", bn: "শিশু" } },
        { value: "unisex", label: { en: "Everyone", bn: "সবার" } },
      ],
    },
    {
      key: "season",
      entity: "item",
      type: "text",
      label: { en: "Collection / season", bn: "কালেকশন / সিজন" },
      required: false,
      searchable: true,
    },
  ],
  variantPresets: [
    { name: { en: "Size", bn: "সাইজ" }, values: ["S", "M", "L", "XL", "XXL"] },
    { name: { en: "Colour", bn: "রং" }, values: ["Black", "White", "Red", "Blue", "Green"] },
  ],
  receiptTemplate: "retail",
  dashboard: [
    "sales_today",
    "gross_profit",
    "cash_in_hand",
    "dues_receivable",
    "dues_payable",
    "low_stock",
    "sales_trend",
  ],
};
